export default __webpack_public_path__ + "src/images/galleries/1/btn_close-d1c2e8.png";